module.exports = __webpack_public_path__ + "img/CRM系统1.ceafcefa.png";